import {atom} from 'jotai';
import {getBrands} from '@/actions/brands';
import type {BrandsState} from '@/types/brands';

const initialState: BrandsState = {
    items: [],
    loading: false,
    error: null,
    initialized: false,
};

export const brandsAtom = atom<BrandsState>(initialState);

export const getBrandsAtom = atom(null, async (_get, set) => {
    set(brandsAtom, (prev: BrandsState) => ({
        ...prev,
        loading: true,
        error: null,
    }));

    try {
        const data = await getBrands();
        set(brandsAtom, (prev: BrandsState) => ({
            ...prev,
            items: data,
            loading: false,
            error: null,
            initialized: true,
        }));
    } catch (error) {
        set(brandsAtom, (prev: BrandsState) => ({
            ...prev,
            loading: false,
            error:
                error instanceof Error
                    ? error.message
                    : 'Failed to fetch brands',
        }));
    }
});
